import { Stack } from 'ui-components';

type Props = React.ComponentProps<typeof Stack>;

export default function GrayBox({ className, children, ...props }: Props): JSX.Element {
  return (
    <Stack className={`m-auto w-72 bg-zinc-100 p-2 text-center ${className}`} {...props}>
      {children}
    </Stack>
  );
}
